const TurnOffAutocomplete = {
  install(Vue) {
    // IOS does not remove readonly-attribute correctly, so:
    const removeReadOnly = function(event) {
      event.target.blur();
      event.target.removeAttribute('readonly');
      event.target.readOnly = false;
      event.target.removeEventListener('focus', removeReadOnly);
      event.target.focus();
    };

    Vue.mixin({
      methods: {
        turnOffAutocomplete() {
          const elements = document.querySelectorAll('[autocomplete="off"]');

          if (!elements) {
            return;
          }

          elements.forEach(element => {
            if (element instanceof HTMLInputElement) { // it can be form, not input
              const backgroundColor = window.getComputedStyle(element, null).getPropertyValue('background-color');
              element.setAttribute('readonly', 'readonly');
              element.style.backgroundColor = backgroundColor;

              element.addEventListener('focus', removeReadOnly, false);
            }
          });
        }
      },

      mounted() {
        this.turnOffAutocomplete();
      },
    });
  }
};

export default TurnOffAutocomplete;
